<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div *ngIf="!loading" fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>edit</mat-icon> Edit Retest Id {{retestId}}
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button type="submit" (click)="onSubmit()" mat-raised-button color="primary" title="Update" [disabled]="authService.isReadOnly()">Update</button>
    &nbsp;&nbsp;
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" mat-raised-button color="basic"
      title="Close">Close</button>
  </div>
</div>

<mat-dialog-content>
  <div *ngIf="!loading">
    <form #form="ngForm" [formGroup]="retestForm" class="form-field-full">

      <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
        
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Voucher Identifier</mat-label>
            <input id="voucherIdentifier" name="voucherIdentifier" formControlName="voucherIdentifier" matInput />
          </mat-form-field>
        </div>
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Original Sample</mat-label>
            <input id="orgininalSampleId" name="orgininalSampleId" formControlName="orgininalSampleId" matInput />
          </mat-form-field>
        </div>
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Retest Sample</mat-label>
            <input id="retestSampleId" name="retestSampleId" formControlName="retestSampleId" matInput />
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Retest Type</mat-label>
            <input id="retestType" name="retestType" formControlName="retestType" matInput />
          </mat-form-field>
        </div>
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Year</mat-label>
            <mat-select id="retestYear" name="retestYear" formControlName="retestYear">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of retestService.retestYears" [value]="item.id">{{item.id}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Quarter</mat-label>
            <mat-select id="retestQuarter" name="retestQuarter" formControlName="retestQuarter">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of retestService.retestQuarters" [value]="item.id">Quarter {{item.id}} (Q{{item.id}})</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Tier</mat-label>
            <mat-select id="tier" name="tier" formControlName="tier">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of retestService.tiers" [value]="item.id">Tier {{item.id}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Completed Date</mat-label>
            <input id="completedDate" name="completedDate" formControlName="completedDate" placeholder="mm/dd/yyyy"
              matInput [matDatepicker]="datepickerCompletedDate" />
            <mat-datepicker-toggle matSuffix [for]="datepickerCompletedDate"></mat-datepicker-toggle>
            <mat-datepicker #datepickerCompletedDate>
              <mat-datepicker-actions>
                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                <button mat-button matDatepickerCancel>Cancel</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
        </div>
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <mat-form-field appearance="standard">
            <mat-label>Due Date</mat-label>
            <input id="dueBy" name="dueBy" formControlName="dueBy" placeholder="mm/dd/yyyy" matInput
              [matDatepicker]="datepickerDueBy" />
            <mat-datepicker-toggle matSuffix [for]="datepickerDueBy"></mat-datepicker-toggle>
            <mat-datepicker #datepickerDueBy>
              <mat-datepicker-actions>
                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                <button mat-button matDatepickerCancel>Cancel</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
        <div fxFlex="33.33" fxFlex.lt-sm="100">
          <br />
          <span >
            <mat-checkbox formControlName="isComplete" (change)="toggleStatusComplete()"></mat-checkbox>
            <mat-label>&nbsp;Completed</mat-label> &nbsp; 
            <br />
          </span>
          <span >
            <mat-checkbox formControlName="incomplete" (change)="toggleStatusIncomplete()"></mat-checkbox>
            <mat-label>&nbsp;Incomplete/Expired</mat-label> &nbsp; 
          </span>
        </div>
      </div>
        <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
        <div fxFlex="100" fxFlex.lt-sm="100">
          <br />
          <mat-form-field>
            <textarea matInput placeholder="Comments" formControlName="comments"></textarea>
          </mat-form-field>
        </div>

        
      </div>

    </form>
  </div>
</mat-dialog-content>